import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBriefcase = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.66406 17.5V5.83333C6.66406 5.05836 6.66406 4.67087 6.74925 4.35295C6.98042 3.49022 7.65428 2.81635 8.51701 2.58519C8.83493 2.5 9.22242 2.5 9.9974 2.5C10.7724 2.5 11.1599 2.5 11.4778 2.58519C12.3405 2.81635 13.0144 3.49022 13.2455 4.35295C13.3307 4.67087 13.3307 5.05836 13.3307 5.83333V17.5M4.33073 17.5H15.6641C16.5975 17.5 17.0642 17.5 17.4207 17.3183C17.7343 17.1586 17.9893 16.9036 18.1491 16.59C18.3307 16.2335 18.3307 15.7668 18.3307 14.8333V8.5C18.3307 7.56658 18.3307 7.09987 18.1491 6.74335C17.9893 6.42975 17.7343 6.17478 17.4207 6.01499C17.0642 5.83333 16.5975 5.83333 15.6641 5.83333H4.33073C3.39731 5.83333 2.9306 5.83333 2.57408 6.01499C2.26047 6.17478 2.00551 6.42975 1.84572 6.74335C1.66406 7.09987 1.66406 7.56658 1.66406 8.5V14.8333C1.66406 15.7668 1.66406 16.2335 1.84572 16.59C2.00551 16.9036 2.26047 17.1586 2.57408 17.3183C2.9306 17.5 3.39731 17.5 4.33073 17.5Z",
		stroke: "#0064FA",
		strokeWidth: 1.25,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgBriefcase;
